import Paper from '@mui/material/Paper';
import React, { useState } from 'react';
import { api, state, ui } from '../../../../../interfaces/interfaces';
import Box from "@mui/material/Box"
import useDebugInformation from '../../../../../hooks/useDebugInformation';
import DrawerList from './DrawerList';
import { useAppSelector } from "@store/hooks";
import CareClubIcon from '../../../../Icons/CareClub';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import GoBackDialog from './GoBackDialog';
import { RightioWBSAPIModelsJobsLast } from '../../../../../utilities/apis/wbs/model';

const updateCaller = (job: RightioWBSAPIModelsJobsLast) => {
    ui.CallerName = `${job.customerTitle}. ${job.customerForename} ${job.customerSurname}`
}

const getCCCustomer = async (job: RightioWBSAPIModelsJobsLast) => {
    let body = {
        email: "",
        foreName: "",
        surname: "",
        phoneLandline: "",
        phoneMobile: "",
        postcode: "",
    }

    if (job.customerSurname) body.surname = job.customerSurname.trim().length > 0 && !job.customerSurname.includes(".") ? job.customerSurname : "";
    if (job.telephoneLandline) body.phoneLandline = job.telephoneLandline.trim().length > 0 ? job.telephoneLandline : (job.customerCLI?.startsWith("07") ? job.customerCLI : "");
    if (job.telephoneMobile) body.phoneMobile = job.telephoneMobile.trim().length > 0 ? job.telephoneMobile : (job.customerCLI?.startsWith("07") ? job.customerCLI : "");
    if (job.postcode) body.postcode = job.postcode

    const result = await api.fetchServiceAgreementCustomer({
        email: "",
        forename: "",
        surname: job.customerSurname,
        phoneLandLine: "",
        postCode: job.postcode,
        phoneMobile: "",
    });
    if (result.length > 0) {
        const serviceAgreementInfo = await api.fetchServiceAgreementInfo({
            serviceAgreementCustomerId: result[0].serviceAgreementCustomerId,
        });

        if (serviceAgreementInfo && serviceAgreementInfo.serviceAgreementRenewal) {
            state.CarePlanRenewal = new Date(serviceAgreementInfo.serviceAgreementRenewal);
            state.CarePlanActive = true
            state.CarePlanStatus = serviceAgreementInfo.serviceAgreementStatus
            state.CarePlanType = serviceAgreementInfo.serviceAgreementType
        }
    }
}

type Props = {}

const JobsDrawer: React.FC<Props> = () => {
    const [open, setOpen] = React.useState(false);
    const [jobid, setJobId] = useState(0);
    const last2 = useAppSelector(({ temp }) => temp.Last2)
    const carePlanActive = useAppSelector(({ state }) => state.CarePlanActive)
    const carePlanStatus = useAppSelector(({ state }) => state.CarePlanStatus)
    const carePlanType = useAppSelector(({ state }) => state.CarePlanType)
    const carePlanRenewal = useAppSelector(({ state }) => state.CarePlanRenewal)
    // const completedJobs = useAppSelector(({ temp }) => temp.CompletedJobs)
    // const jobReviews = useAppSelector(({ temp }) => temp.JobReviews)
    // const done = useAppSelector(({ state }) => state.JobReviewsFetched)

    React.useEffect(() => {
        if (last2 && last2.length > 0) {
            updateCaller(last2[0])
            getCCCustomer(last2[0])
        }
    }, [last2, carePlanActive])

    useDebugInformation("JobsDrawer", { open, jobid, last2, })
    return (
        <Box id="right-panel" sx={{ width: 260, m: 0 }}>
            <GoBackDialog open={open} setOpen={setOpen} jobId={jobid} />
            {last2 && last2.length > 0 && (
                <Paper sx={(theme) => ({
                    width: "fit-content",
                    boxShadow: theme.shadows[2],
                    margin: theme.spacing(0),
                    // marginBottom: theme.spacing(0),
                    padding: theme.spacing(1),
                    [theme.breakpoints.up(600 + Number(theme.spacing(3)) * 2)]: {
                        margin: theme.spacing(0),
                        padding: theme.spacing(1),
                    },
                })} elevation={2} variant="elevation">
                    <DrawerList setJobId={setJobId} setOpen={setOpen} />
                </Paper>
            )}
            {carePlanActive &&
                <Stack spacing={2}>
                    <CareClubIcon style={{
                        height: "auto",
                        width: "fit-content",
                        margin: 20,
                        backgroundColor: "#401e45",
                        fill: "#fff",
                        padding: 15,
                        borderRadius: 15,
                        marginInline: 30,
                        marginTop: 10,
                        marginBottom: 0,
                        boxShadow: "2px 2px 2px 2px #a6a6a6"
                    }} component={'symbol'} />
                    <Typography variant="h6" textAlign="center" color="red">{carePlanType?.name}</Typography>
                    <Typography variant="h6" textAlign="center" color="red" sx={{ marginTop: "0 !important" }}>{`${carePlanStatus?.description} until ${carePlanRenewal && typeof carePlanRenewal === "string" ? new Date(carePlanRenewal).toLocaleDateString("en-GB") : carePlanRenewal.toLocaleDateString("en-GB")}`}</Typography>
                </Stack>
            }
        </Box>
    );
}

export default React.memo(JobsDrawer)